<div class="row mt-3 mb-3">
  <div class="col-12">
    <button (click)="adicionar()" [disabled]="disabled()" class="btn btn-sm btn-outline-primary">
      <img src="assets/img/global/plus.png" alt="adicionar" title="Adicionar" height="16" width="16">
      Adicionar
    </button>
    <button (click)="importarResponsaveis()" [disabled]="disabled()" class="btn btn-sm btn-link float-right">
      Importar Responsáveis
    </button>
  </div>
</div>
<table class="table table-sm" *ngIf="lista && lista.length > 0">
  <thead>
    <tr>
      <th style="width: 5%" scope="col"></th>
      <th style="width: 35%" scope="col">Nome</th>
      <th style="width: 15%" scope="col">CPF</th>
      <th style="width: 25%" scope="col">E-mail</th>
      <th style="width: 10%" scope="col">Contratante</th>
      <th style="width: 10%" scope="col">Ativo</th>
      <th style="width: 10%" scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of lista; let idx = index">
      <td style="width: 5%">
        <button (click)="visualizarPessoa(item)" class="btn btn-sm btn-outline-secondary mr-2">
          <em class="fa fa-eye"></em>
        </button>
      </td>
      <td *ngIf="!item.editavel" style="width: 35%">{{item.responsavel.nome}}</td>
      <td *ngIf="!item.editavel" style="width: 15%">{{item.responsavel.cpf_cnpj | CPF}}</td>
      <td *ngIf="!item.editavel" style="width: 25%">
        {{item.responsavel.email}}
        <span class="d-block">{{item.responsavel.email_profissional}}</span>
      </td>
      <td *ngIf="item.editavel" style="width: 75%" [attr.colspan]="'3'">
        <p-autoComplete [(ngModel)]="item.responsavel" [field]="pessoaAutoComplete.conversor"
          [suggestions]="pessoaAutoComplete.lista" (completeMethod)="pessoaAutoComplete.filtrar($event)"
          inputStyleClass="form-control autocomplete-radius-right" minLength="2"
          [style]="{ width: 'calc(100% - 46px)', float: 'left' }" [forceSelection]="true" [autoHighlight]="true"
          *ngIf="pessoaAutoComplete">
          <ng-template let-pessoa pTemplate="item">
            {{pessoa.cpf_cnpj | CPF}} {{pessoa.nome}} {{pessoa.email}}
          </ng-template>
        </p-autoComplete>
        <button class="btn btn-outline-secondary float-right" type="button" (click)="cadastroPessoa(item)"
          style="height: 36px; border-bottom-left-radius: 0px;  border-top-left-radius: 0px;">
          <em class="fa fa-user-plus"></em>
        </button>
      </td>

      <td style="width: 10%" *ngIf="item.editavel">
        <div class="checkbox checbox-switch switch-primary">
          <label>
            <input type="checkbox" [(ngModel)]="item.contratante" [ngModelOptions]="{standalone: true}" />
            <span></span>
          </label>
        </div>
      </td>
      <td *ngIf="!item.editavel">
        <span [class]="'badge badge-' + (item.contratante ? 'success' : 'danger')">
          {{item.contratante ? 'Contratante' : 'Contratado'}}
        </span>
      </td>

      <td style="width: 10%" *ngIf="item.editavel">
        <div class="checkbox checbox-switch switch-success">
          <label>
            <input type="checkbox" [(ngModel)]="item.ativo" [ngModelOptions]="{standalone: true}" />
            <span></span>
          </label>
        </div>
      </td>
      <td *ngIf="!item.editavel">
        <span [class]="'badge badge-' + (item.ativo ? 'success' : 'danger')">
          {{item.ativo ? 'Sim' : 'Não'}}
        </span>
      </td>

      <td class="text-right" style="width: 10%">
        <table style="width: 100%;" >
          <td *ngIf="item.editavel" style="border-top: none;">
            <button *ngIf="item.editavel" (click)="salvar(item)" class="btn btn-sm btn-outline-secondary mr-2">
              <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
            </button>
          </td>
          <td *ngIf="item.editavel" style="border-top: none;">
            <button *ngIf="item.editavel" (click)="cancelar(item, idx)" class="btn btn-sm btn-outline-primary">
              <img src="assets/img/global/cross.png" alt="editar" height="16" width="16">
            </button>
          </td>
          <td *ngIf="!item.editavel" style="border-top: none;">
            <button *ngIf="!item.editavel" (click)="editar(item)" [disabled]="disabled()"
              class="btn btn-sm btn-outline-primary mr-2">
              <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
            </button>
          </td>
          <td *ngIf="!item.editavel" style="border-top: none;">
            <button *ngIf="!item.editavel" (click)="remover(item, idx)" [disabled]="disabled()"
              class="btn btn-sm btn-outline-primary">
              <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
            </button>
          </td>
        </table>
      </td>
    </tr>
  </tbody>
</table>
<lib-pessoa-cadastro-dlg [entity]="cadPessoa" [login]="login" (callback)="callbackPessoa($event)">
</lib-pessoa-cadastro-dlg>
<lib-pessoa-visualizar-dlg [entity]="viewPessoa"></lib-pessoa-visualizar-dlg>